App.BonusLogBlockComponent = Em.Component.extend
  classNames: 'bonus-log-block'
  store: Em.inject.service('store')
  env: Em.inject.service('environment')

  order: null

  orderObserver: (->
    return unless @get('log.order_id')
    @get('store').find('order', @get('log.order_id'))
    .then (order) =>
      @set('order', order)
  ).observes('log.order_id').on('init')

  isPositive: (->
    @get('log.operation') is 'add'
  ).property('log.operation')

  formattedBonusesCount: (->
    amount = @get('log.amount')
    Math.abs(amount)
  ).property('log.amount')

  formattedBonusesValue: (->
    sign = if @get('isPositive') then '+' else '-'
    amount = @get('log.amount')
    numeral("#{sign}#{amount}").format("#{sign}0,0.0")
  ).property('log.amount')

  actions: 
    openOrder: (log) ->
      return unless log.order_id
      App.__container__.lookup('controller:application').transitionToRoute('orders.list.order', log.order_id)